import { Reducer } from 'redux'

import { ITikTokState, TikTokActionTypes } from './types'

export const initialState: ITikTokState = {
  step: 1,
  businessCenters: [],
  isAuthLoading: false,
  isAuthError: false,
  errors: null,
  authCode: '',
  isBusinessCentersLoading: true,
  redirect: '',
  isRequestsLoading: false,
}

const reducer: Reducer<ITikTokState> = (state = initialState, action: any) => {
  switch (action.type) {
    case TikTokActionTypes.SET_TIKTOK_STEP: {
      return { ...state, step: action.data }
    }
    case TikTokActionTypes.SET_TIKTOK_BUSINESS_CENTERS: {
      return {
        ...state,
        businessCenters: action.data,
      }
    }
    case TikTokActionTypes.SET_TIKTOK_AUTH_ERROR: {
      return {
        ...state,
        isAuthError: action.data,
      }
    }
    case TikTokActionTypes.SET_TIKTOK_AUTH_LOADING: {
      return {
        ...state,
        isAuthLoading: action.data,
      }
    }
    case TikTokActionTypes.SET_TIKTOK_AUTH_CODE: {
      return {
        ...state,
        authCode: action.data,
      }
    }
    case TikTokActionTypes.SET_TIKTOK_BUSINESS_CENTERS_LOADING: {
      return {
        ...state,
        isBusinessCentersLoading: action.data,
      }
    }
    case TikTokActionTypes.SET_TIKTOK_ERRORS: {
      return {
        ...state,
        errors: action.data,
      }
    }
    case TikTokActionTypes.SET_TIKTOK_REDIRECT: {
      return {
        ...state,
        redirect: action.data,
      }
    }
    case TikTokActionTypes.SET_TIKTOK_REQUESTS_LOADING: {
      return {
        ...state,
        isRequestsLoading: action.data,
      }
    }
    default: {
      return state
    }
  }
}

export { reducer as tikTokReducer }
